module.exports = "<h3 class=\"topless\">Ledger Settings</h3>\n<form (ngSubmit)=\"save()\">\n  <section fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"10px\">\n    <mat-input-container>\n      <input matInput [(ngModel)]=\"ledger.name\" name=\"name\" placeholder=\"Ledger Name\" />\n    </mat-input-container>\n\n    <button mat-button color=\"primary\">Save</button>\n    <a mat-button routerLink=\"/account\">Cancel</a>\n  </section>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// /srv/src/app/settings/ledger.component.html
// module id = ../../../../../src/app/settings/ledger.component.html
// module chunks = main